import { useEffect } from 'react';

import { cn } from '@/lib/utils';

import { prefetchDefaultDashboardChunk } from './helpers/app-boot-splash-variants';

interface AppBootSplashProps {
  className?: string;
}

const APP_BOOT_SPLASH_LABEL = 'Loading Upstack Data';
const APP_BOOT_SPLASH_HINT = 'Preparing your workspace';
export function AppBootSplash({ className }: AppBootSplashProps) {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    prefetchDefaultDashboardChunk(window.location.pathname);
  }, []);

  return (
    <div
      aria-label={APP_BOOT_SPLASH_LABEL}
      aria-live="polite"
      className={cn('app-splash', className)}
      role="status"
    >
      <div className="app-splash__content">
        <div aria-hidden="true" className="app-splash__spinner" />
        <p className="app-splash__label">{APP_BOOT_SPLASH_LABEL}</p>
        <p className="app-splash__hint">{APP_BOOT_SPLASH_HINT}</p>
      </div>
    </div>
  );
}
